export class ReadMoreHelper {
	static disabledReadmore(height: number, isSmallTablet: boolean): boolean {
		const lineClamps = { DEFAULT: 144, md: 96 };
		const lineClamp = isSmallTablet ? lineClamps.DEFAULT : lineClamps.md;

		return height <= lineClamp;
	}
}
